//Disable for non-KMX hosts in prod
export const checkHost = (): boolean => {
    if (process.env.ENV === 'production' && window.location.host === 'www.carmax.com') {
        return true;
    }
    if (process.env.ENV !== 'production') {
        return true;
    }
    return false;
};
